module.exports = __webpack_public_path__ + "static/media/sensor.b4b488e2.png";